var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.customMessage
    ? _c("p", [
        _vm.confirmationMessageStatus
          ? _c("span", [
              _vm._v(
                _vm._s(_vm.Lang.get("messages.delete_confirmation")) + " ("
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.message
          ? _c("span", [_vm._v("\n    " + _vm._s(_vm.message) + "\n    ")])
          : _vm._e(),
        _vm._v(" "),
        _vm.confirmationMessageStatus
          ? _c("span", [
              _vm._v(")" + _vm._s(_vm.Lang.get("messages.question_mark"))),
            ])
          : _vm._e(),
      ])
    : _c("p", [
        _c("span", [_vm._v("\n    " + _vm._s(_vm.customMessage) + "\n  ")]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }